import { Component } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TrailerService } from 'src/app/services/trailer.service';
import { UtilsService } from 'src/app/services/utils.service';


declare const $: any;

@Component({
  selector: 'app-trailer-add',
  templateUrl: './trailer-add.component.html',
  styleUrls: ['./trailer-add.component.css']
})
export class TrailerAddComponent {
  constructor(
    private fb: FormBuilder,
    private utils: UtilsService,
    private spinner: NgxSpinnerService,
    private apiTrailer: TrailerService,
    private router: Router
  ) { }

  formModelData: any = {
    trailer: null,
    plate: null,
    year: null,
    trailer_type_id: '',
    active: true
  }

  trailerTypes: any[] = []

  trailerForm!: FormGroup

  ngOnInit(): void {
    this.trailerForm = this.fb.group({
      trailer: ['', Validators.required],
      plate: ['', Validators.required],
      year: ['', Validators.required],
      trailer_type_id: ['', Validators.required],
      active: [true, Validators.required]
    })

    this.apiTrailer.getTrailerTypes().subscribe((resp: any) => {
      this.trailerTypes = resp || []
    })
  }

  addTrailer() {
    if (this.trailerForm.valid) {
      this.spinner.show()
      const payload: any = { ...this.formModelData }
      payload.active = payload.active ? '1' : '0'

      this.apiTrailer.addTrailer(payload).subscribe((resp: any) => {
        this.spinner.hide()
        $("#formTrailer")[0].reset()
        this.trailerForm.reset({ active: true })
        this.formModelData = {
          trailer: null,
          plate: null,
          year: null,
          trailer_type_id: '',
          active: true
        }
        this.utils.alertSwal({ title: 'Exitoso', text: resp.msg, icon: 'success' })

        this.router.navigateByUrl('/trailer/list')
      }, () => {
        this.spinner.hide()
        this.utils.alertSwal({ title: 'Error!', text: 'Se ha presentado un error al insertar remolque', icon: 'error' })
      })
    } else {
      this.utils.alertSwal({ title: 'Advertencia', text: 'Verifique que la información se encuentre completa.', icon: 'warning' })
    }
  }

  goToChecklist() {
    this.router.navigateByUrl('/unit/checklist', { state: { data: this.formModelData } });
  }

  get registerFormControl() {
    return this.trailerForm.controls;
  }
}
